import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Tab, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { userDownloadFile } from '../../actions/userActions';
import ConfirmDialog from './ConfirmDialog';
import Button from './Button';
import Iframe from 'react-iframe';

const videos = [
// {
//     'title': 'Introduction',
//     'src': 'https://www.useloom.com/embed/2c6ec56508f14410813c4dcf1833fcbf'
// },
{
    'title': 'Overview',
    'src': 'https://www.useloom.com/embed/cac0cdac2376485ea8dee1f218e341f6'
},
{
    'title': 'Account Setup',
    'src': 'https://www.useloom.com/embed/6d5b36dfda194ad19d893564c52854ca'
},
{
    'title': 'New Case',
    'src': 'https://www.useloom.com/embed/8ec8266d62224203b462decf5de8675c'
},
{
    'title': 'Public Intake',
    'src': 'https://www.useloom.com/embed/4fd5ca6f4454429dbb9028b645ea6fd6'
},
{
    'title': 'Intake Form',
    'src': 'https://www.useloom.com/embed/c0ab3d013f99436e92089a238959ca8b'
},
{
    'title': 'Intake Form - Custom Case Types',
    'src': 'https://www.useloom.com/embed/addeafa356e445dea24c9c53734e4e19'
},
{
    'title': 'Form Editor - Overview',
    'src': 'https://www.useloom.com/embed/5448b877d4b74ea7886c2b4127d5f2a2'
},
{
    'title': 'Form Editor - Fields',
    'src': 'https://www.useloom.com/embed/5157ee451c4045a1ae8c3acfd74503fc'
},
{
    'title': 'Payment Tab',
    'src': 'https://www.useloom.com/embed/f5b8cdf356cb4fef9b9b81c065190f9e'
},
{
    'title': 'Document Automation',
    'src': 'https://www.useloom.com/embed/84ed7713bd3b4bc7a5fee41e2120b19e'
},
{
    'title': 'E-Sign',
    'src': 'https://www.useloom.com/embed/53b148e712134a5b891bebac6c4aad24'
},
{
    'title': 'E-Pay',
    'src': 'https://www.useloom.com/embed/17f1931f30274406821889c1eabb6198'
},
{
    'title': 'Email',
    'src': 'https://www.useloom.com/embed/e73addb5f2a14571b67a3cf5ef167dad'
},
{
    'title': 'Documents Tab / Faxing',
    'src': 'https://www.useloom.com/embed/695e6afcd75a4ccabb438e79495ba9cc'
},
{
    'title': 'Notes Tab',
    'src': 'https://www.useloom.com/embed/f9c80827fa0446ba948a41c40db8208a'
},
{
    'title': 'Contacts Overview',
    'src': 'https://www.useloom.com/embed/252d1169aa1d4fc689f98f998cd99a3e'
},
{
    'title': 'Using Contacts',
    'src': 'https://www.useloom.com/embed/0b1ff362c07c4f46a82a9a3bbceb1faf'
},
{
    'title': 'Tasks / Calendar Integration',
    'src': 'https://www.useloom.com/embed/dd387ca59247493583c5893bb525a34c'
},
{
    'title': 'Tasklists',
    'src': 'https://www.useloom.com/embed/c7095db849e84f1aaa1f7969ae5a5e96'
}
// {
//     'title': 'Searching / Filtering',
//     'src': ''
// }
];


class HelpDialog extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            selected: 0
        }
    }

    render() {
        return (
            <ConfirmDialog title='Help'
                           cancel={() => {this.props.close()}}
                           open={this.props.open}
                           size='full'>
                    <Tab.Container defaultActiveKey={0}
                                   activeKey={this.state.selected}
                                   onSelect={key => {this.setState({selected: key})}}>
                        <div>
                        <Row>
                            <Col sm={12}>
                                <Nav bsStyle="pills">
                                    <NavItem eventKey={0}><b>User Guide</b></NavItem>
                                    {videos.map((video, index) => {
                                        return (<NavItem eventKey={index + 1}>{video['title']}</NavItem>);
                                    })}
                                </Nav>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Tab.Content animation>
                                    <Tab.Pane eventKey={0}>
                                        <Row style={{'paddingTop': '10%'}}>
                                            <Col xs={4}></Col>
                                            <Col xs={4}>
                                                <Button bsStyle="primary"
                                                        block
                                                        onClick={evt => {
                                                            window.open('https://drive.google.com/file/d/192lpxB9DkQE0PdKFAJprer-Z1ZhhmG4g/view?usp=sharing');
                                                        }}
                                                        label="Download User Guide"/>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    {videos.map((video, index) => {
                                        return (
                                        <Row>
                                            <Col xs={12}>
                                                <Tab.Pane eventKey={index + 1}>
                                                {this.state.selected == index + 1 && (
                                                    <Iframe url={video['src']}
                                                            width="100%"
                                                            height="500px"
                                                            display="initial"
                                                            position="relative"
                                                            allowFullScreen />
                                                )}
                                                </Tab.Pane>
                                            </Col>
                                        </Row>);
                                    })}
                                </Tab.Content>
                            </Col>
                        </Row>
                        </div>
                    </Tab.Container>
            </ConfirmDialog>
        );
    }
}

HelpDialog.propTypes = {
    close: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default connect()(HelpDialog);
